import React from 'react';
import styles from './banner.module.css';
import bannerImage from './banner.png';

const Banner = ({ title }) => {
    return (
        <div 
            className={styles.banner} 
            style={{ backgroundImage: `url(${bannerImage})` }}
        >
            <h1 className={styles.title}>{title}</h1>
        </div>
    );
};

export default Banner;
